/**
 * LandingHeader - Navigation header for landing page
 */
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sun, Moon, ArrowRight } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { useTranslation } from '../../i18n';

const LandingHeader = ({ user }) => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img 
              src="/images/parachpay-logo.jpg" 
              alt="ParachPay Logo" 
              width="40"
              height="40"
              className="h-10 w-auto"
              data-testid="landing-logo"
            />
            <span className="hidden min-[420px]:inline font-bold text-xl tracking-wide">PARACHPAY</span>
          </Link>
          <div className="flex items-center gap-1 sm:gap-2 min-w-0">
            <LanguageSwitcher variant="icon" />
            <Button variant="ghost" size="icon" onClick={toggleTheme} data-testid="landing-theme-toggle">
              {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </Button>
            {user ? (
              <Link to="/dashboard">
                <Button className="rounded-full px-6" data-testid="go-to-dashboard-btn">
                  {t('nav.dashboard')}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost" className="hidden sm:inline-flex" data-testid="login-btn">
                    {t('landing.signIn')}
                  </Button>
                </Link>
                <Link to="/register">
                  <Button className="rounded-full px-4 sm:px-6 whitespace-nowrap" data-testid="get-started-btn">
                    {t('landing.getStarted')}
                    <ArrowRight className="hidden sm:inline w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
